




















































































































import cloneDeep from 'lodash/cloneDeep';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'

import uniq from 'lodash/uniq';
import moment from 'moment';

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'lastMeta', 'last_deals'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'exportData', 'exportAsXLSX'
    ])
  },
  components: {
    TitleBar
  }
})
export default class Catalog extends Vue {
  // radioButton = 1;
  // open = false

  opened: any[] = [];

  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  get titleStack () {
    return [
      'Главная страница'
    ]
  }

  onDealSample(container: any) {
    this.$store.dispatch(`${STORE_KEY}/requestSample`, container)
    .then((result) => {
      this.$buefy.snackbar.open(`Отправлен запрос на образец `);
    })
    .catch(() => {
      this.$buefy.snackbar.open({
        type: 'is-warning',
        message: `При сохранении возникли проблемы. Попробуйте позже.`
      })
    })
  }

  onDetailToggle(row: any, to: string) {
    if (to == 'open') {
      this.opened = uniq([
        ...this.opened,
        row.id
      ]);
    } else {
      this.opened = uniq(
        this.opened.filter(($row) => $row.id != row.id)
      );
    }
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null
  }

  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }
  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // this.checkFilterChange();
    this.handleParamsChange();
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
